export default __webpack_public_path__ + "static/assignment-0afa423e5c6a1834b7fc49a1ca35c975.png";